import Button from '@hellodarwin/core/lib/components/common/button';
import { Carousel } from 'antd/es';
import type { CarouselRef } from 'antd/es/carousel';
import React, { useRef } from 'react';
import { CarouselContainer, CarouselWrapper } from './styles';
import { CarrouselImageWrapper } from './styles';

interface OnboardingCarrouselProps {
  images: string[];
  autoplay?: boolean;
  height?: string;
  width?: string;
}

const OnboardingCarrousel: React.FC<OnboardingCarrouselProps> = ({
  images,
  autoplay = true,
  height,
  width,
}) => {
  const carouselRef = useRef<CarouselRef>(null);

  const handleArrowClick = (direction: 'left' | 'right') => {
    if (carouselRef.current) {
      if (direction === 'left') {
        carouselRef.current.prev();
      } else {
        carouselRef.current.next();
      }
    }
  };

  if (!images || images.length === 0) return null;

  return (
    <CarouselWrapper>
      <Button
        className="arrow-wrapper arrow-left"
        withArrowLeft
        size="small"
        transparent
        onClick={() => handleArrowClick('left')}
      />
      <CarouselContainer $height={height} $width={width}>
        <Carousel
          autoplay={autoplay}
          dots={false}
          ref={carouselRef}
          style={{ background: 'transparent' }}
        >
          {images.map((src, index) => (
            <CarrouselImageWrapper key={index} className="image-wrapper">
              <img src={src} alt={`Onboarding slide ${index + 1}`} />
            </CarrouselImageWrapper>
          ))}
        </Carousel>
      </CarouselContainer>
      <Button
        className="arrow-wrapper arrow-right"
        withArrowRight
        size="small"
        transparent
        onClick={() => handleArrowClick('right')}
      />
    </CarouselWrapper>
  );
};

export default OnboardingCarrousel;
